"use strict";
var moneyFormats = {
  USD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} USD",
  },
  EUR: {
    money_format: "&euro;{{amount}}",
    money_with_currency_format: "&euro;{{amount}} EUR",
  },
  GBP: {
    money_format: "&pound;{{amount}}",
    money_with_currency_format: "&pound;{{amount}} GBP",
  },
  CAD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} CAD",
  },
  ALL: {
    money_format: "Lek {{amount}}",
    money_with_currency_format: "Lek {{amount}} ALL",
  },
  DZD: {
    money_format: "DA {{amount}}",
    money_with_currency_format: "DA {{amount}} DZD",
  },
  AOA: {
    money_format: "Kz{{amount}}",
    money_with_currency_format: "Kz{{amount}} AOA",
  },
  ARS: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} ARS",
  },
  AMD: {
    money_format: "{{amount}} AMD",
    money_with_currency_format: "{{amount}} AMD",
  },
  AWG: {
    money_format: "Afl{{amount}}",
    money_with_currency_format: "Afl{{amount}} AWG",
  },
  AUD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} AUD",
  },
  BBD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} Bds",
  },
  AZN: {
    money_format: "m.{{amount}}",
    money_with_currency_format: "m.{{amount}} AZN",
  },
  BDT: {
    money_format: "Tk {{amount}}",
    money_with_currency_format: "Tk {{amount}} BDT",
  },
  BSD: {
    money_format: "BS${{amount}}",
    money_with_currency_format: "BS${{amount}} BSD",
  },
  BHD: {
    money_format: "{{amount}}0 BD",
    money_with_currency_format: "{{amount}}0 BHD",
  },
  BYR: {
    money_format: "Br {{amount}}",
    money_with_currency_format: "Br {{amount}} BYR",
  },
  BZD: {
    money_format: "BZ${{amount}}",
    money_with_currency_format: "BZ${{amount}} BZD",
  },
  BTN: {
    money_format: "Nu {{amount}}",
    money_with_currency_format: "Nu {{amount}} BTN",
  },
  BAM: {
    money_format: "KM {{amount_with_comma_separator}}",
    money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
  },
  BRL: {
    money_format: "R$ {{amount_with_comma_separator}}",
    money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
  },
  BOB: {
    money_format: "Bs{{amount_with_comma_separator}}",
    money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
  },
  BWP: {
    money_format: "P{{amount}}",
    money_with_currency_format: "P{{amount}} BWP",
  },
  BND: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} BND",
  },
  BGN: {
    money_format: "{{amount}} лв",
    money_with_currency_format: "{{amount}} лв BGN",
  },
  MMK: {
    money_format: "K{{amount}}",
    money_with_currency_format: "K{{amount}} MMK",
  },
  KHR: {
    money_format: "KHR{{amount}}",
    money_with_currency_format: "KHR{{amount}}",
  },
  KYD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} KYD",
  },
  XAF: {
    money_format: "FCFA{{amount}}",
    money_with_currency_format: "FCFA{{amount}} XAF",
  },
  CLP: {
    money_format: "${{amount_no_decimals}}",
    money_with_currency_format: "${{amount_no_decimals}} CLP",
  },
  CNY: {
    money_format: "&#165;{{amount}}",
    money_with_currency_format: "&#165;{{amount}} CNY",
  },
  COP: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} COP",
  },
  CRC: {
    money_format: "&#8353; {{amount_with_comma_separator}}",
    money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC",
  },
  HRK: {
    money_format: "{{amount_with_comma_separator}} kn",
    money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
  },
  CZK: {
    money_format: "{{amount_with_comma_separator}} K&#269;",
    money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
  },
  DKK: {
    money_format: "{{amount_with_comma_separator}}",
    money_with_currency_format: "kr.{{amount_with_comma_separator}}",
  },
  DOP: {
    money_format: "RD$ {{amount}}",
    money_with_currency_format: "RD$ {{amount}}",
  },
  XCD: {
    money_format: "${{amount}}",
    money_with_currency_format: "EC${{amount}}",
  },
  EGP: {
    money_format: "LE {{amount}}",
    money_with_currency_format: "LE {{amount}} EGP",
  },
  ETB: {
    money_format: "Br{{amount}}",
    money_with_currency_format: "Br{{amount}} ETB",
  },
  XPF: {
    money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
    money_with_currency_format:
      "{{amount_no_decimals_with_comma_separator}} XPF",
  },
  FJD: {
    money_format: "${{amount}}",
    money_with_currency_format: "FJ${{amount}}",
  },
  GMD: {
    money_format: "D {{amount}}",
    money_with_currency_format: "D {{amount}} GMD",
  },
  GHS: {
    money_format: "GH&#8373;{{amount}}",
    money_with_currency_format: "GH&#8373;{{amount}}",
  },
  GTQ: {
    money_format: "Q{{amount}}",
    money_with_currency_format: "{{amount}} GTQ",
  },
  GYD: {
    money_format: "G${{amount}}",
    money_with_currency_format: "${{amount}} GYD",
  },
  GEL: {
    money_format: "{{amount}} GEL",
    money_with_currency_format: "{{amount}} GEL",
  },
  HNL: {
    money_format: "L {{amount}}",
    money_with_currency_format: "L {{amount}} HNL",
  },
  HKD: {
    money_format: "${{amount}}",
    money_with_currency_format: "HK${{amount}}",
  },
  HUF: {
    money_format: "{{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format:
      "{{amount_no_decimals_with_comma_separator}} Ft",
  },
  ISK: {
    money_format: "{{amount_no_decimals}} kr",
    money_with_currency_format: "{{amount_no_decimals}} kr ISK",
  },
  INR: {
    money_format: "Rs. {{amount}}",
    money_with_currency_format: "Rs. {{amount}}",
  },
  IDR: {
    money_format: "{{amount_with_comma_separator}}",
    money_with_currency_format: "Rp {{amount_with_comma_separator}}",
  },
  ILS: {
    money_format: "{{amount}} NIS",
    money_with_currency_format: "{{amount}} NIS",
  },
  JMD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} JMD",
  },
  JPY: {
    money_format: "&#165;{{amount_no_decimals}}",
    money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
  },
  JEP: {
    money_format: "&pound;{{amount}}",
    money_with_currency_format: "&pound;{{amount}} JEP",
  },
  JOD: {
    money_format: "{{amount}}0 JD",
    money_with_currency_format: "{{amount}}0 JOD",
  },
  KZT: {
    money_format: "{{amount}} KZT",
    money_with_currency_format: "{{amount}} KZT",
  },
  KES: {
    money_format: "KSh{{amount}}",
    money_with_currency_format: "KSh{{amount}}",
  },
  KWD: {
    money_format: "{{amount}}0 KD",
    money_with_currency_format: "{{amount}}0 KWD",
  },
  KGS: {
    money_format: "лв{{amount}}",
    money_with_currency_format: "лв{{amount}}",
  },
  LVL: {
    money_format: "Ls {{amount}}",
    money_with_currency_format: "Ls {{amount}} LVL",
  },
  LBP: {
    money_format: "L&pound;{{amount}}",
    money_with_currency_format: "L&pound;{{amount}} LBP",
  },
  LTL: {
    money_format: "{{amount}} Lt",
    money_with_currency_format: "{{amount}} Lt",
  },
  MGA: {
    money_format: "Ar {{amount}}",
    money_with_currency_format: "Ar {{amount}} MGA",
  },
  MKD: {
    money_format: "ден {{amount}}",
    money_with_currency_format: "ден {{amount}} MKD",
  },
  MOP: {
    money_format: "MOP${{amount}}",
    money_with_currency_format: "MOP${{amount}}",
  },
  MVR: {
    money_format: "Rf{{amount}}",
    money_with_currency_format: "Rf{{amount}} MRf",
  },
  MXN: {
    money_format: "$ {{amount}}",
    money_with_currency_format: "$ {{amount}} MXN",
  },
  MYR: {
    money_format: "RM{{amount}} MYR",
    money_with_currency_format: "RM{{amount}} MYR",
  },
  MUR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} MUR",
  },
  MDL: {
    money_format: "{{amount}} MDL",
    money_with_currency_format: "{{amount}} MDL",
  },
  MAD: {
    money_format: "{{amount}} dh",
    money_with_currency_format: "Dh {{amount}} MAD",
  },
  MNT: {
    money_format: "{{amount_no_decimals}} &#8366",
    money_with_currency_format: "{{amount_no_decimals}} MNT",
  },
  MZN: {
    money_format: "{{amount}} Mt",
    money_with_currency_format: "Mt {{amount}} MZN",
  },
  NAD: {
    money_format: "N${{amount}}",
    money_with_currency_format: "N${{amount}} NAD",
  },
  NPR: {
    money_format: "Rs{{amount}}",
    money_with_currency_format: "Rs{{amount}} NPR",
  },
  ANG: {
    money_format: "&fnof;{{amount}}",
    money_with_currency_format: "{{amount}} NA&fnof;",
  },
  NZD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} NZD",
  },
  NIO: {
    money_format: "C${{amount}}",
    money_with_currency_format: "C${{amount}} NIO",
  },
  NGN: {
    money_format: "&#8358;{{amount}}",
    money_with_currency_format: "&#8358;{{amount}} NGN",
  },
  NOK: {
    money_format: "kr {{amount_with_comma_separator}}",
    money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
  },
  OMR: {
    money_format: "{{amount_with_comma_separator}} OMR",
    money_with_currency_format: "{{amount_with_comma_separator}} OMR",
  },
  PKR: {
    money_format: "Rs.{{amount}}",
    money_with_currency_format: "Rs.{{amount}} PKR",
  },
  PGK: {
    money_format: "K {{amount}}",
    money_with_currency_format: "K {{amount}} PGK",
  },
  PYG: {
    money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format:
      "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
  },
  PEN: {
    money_format: "S/. {{amount}}",
    money_with_currency_format: "S/. {{amount}} PEN",
  },
  PHP: {
    money_format: "&#8369;{{amount}}",
    money_with_currency_format: "&#8369;{{amount}} PHP",
  },
  PLN: {
    money_format: "{{amount_with_comma_separator}} zl",
    money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
  },
  QAR: {
    money_format: "QAR {{amount_with_comma_separator}}",
    money_with_currency_format: "QAR {{amount_with_comma_separator}}",
  },
  RON: {
    money_format: "{{amount_with_comma_separator}} lei",
    money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
  },
  RUB: {
    money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    money_with_currency_format:
      "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
  },
  RWF: {
    money_format: "{{amount_no_decimals}} RF",
    money_with_currency_format: "{{amount_no_decimals}} RWF",
  },
  WST: {
    money_format: "WS$ {{amount}}",
    money_with_currency_format: "WS$ {{amount}} WST",
  },
  SAR: {
    money_format: "{{amount}} SR",
    money_with_currency_format: "{{amount}} SAR",
  },
  STD: {
    money_format: "Db {{amount}}",
    money_with_currency_format: "Db {{amount}} STD",
  },
  RSD: {
    money_format: "{{amount}} RSD",
    money_with_currency_format: "{{amount}} RSD",
  },
  SCR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} SCR",
  },
  SGD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} SGD",
  },
  SYP: {
    money_format: "S&pound;{{amount}}",
    money_with_currency_format: "S&pound;{{amount}} SYP",
  },
  ZAR: {
    money_format: "R {{amount}}",
    money_with_currency_format: "R {{amount}} ZAR",
  },
  KRW: {
    money_format: "&#8361;{{amount_no_decimals}}",
    money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
  },
  LKR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} LKR",
  },
  SEK: {
    money_format: "{{amount_no_decimals}} kr",
    money_with_currency_format: "{{amount_no_decimals}} kr SEK",
  },
  CHF: {
    money_format: "SFr. {{amount}}",
    money_with_currency_format: "SFr. {{amount}} CHF",
  },
  TWD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} TWD",
  },
  THB: {
    money_format: "{{amount}} &#xe3f;",
    money_with_currency_format: "{{amount}} &#xe3f; THB",
  },
  TZS: {
    money_format: "{{amount}} TZS",
    money_with_currency_format: "{{amount}} TZS",
  },
  TTD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} TTD",
  },
  TND: {
    money_format: "{{amount}}",
    money_with_currency_format: "{{amount}} DT",
  },
  TRY: {
    money_format: "{{amount}}TL",
    money_with_currency_format: "{{amount}}TL",
  },
  UGX: {
    money_format: "Ush {{amount_no_decimals}}",
    money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
  },
  UAH: {
    money_format: "₴{{amount}}",
    money_with_currency_format: "₴{{amount}} UAH",
  },
  AED: {
    money_format: "Dhs. {{amount}}",
    money_with_currency_format: "Dhs. {{amount}} AED",
  },
  UYU: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} UYU",
  },
  VUV: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}}VT",
  },
  VEF: {
    money_format: "Bs. {{amount_with_comma_separator}}",
    money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
  },
  VND: {
    money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
    money_with_currency_format:
      "{{amount_no_decimals_with_comma_separator}} VND",
  },
  XBT: {
    money_format: "{{amount_no_decimals}} BTC",
    money_with_currency_format: "{{amount_no_decimals}} BTC",
  },
  XOF: {
    money_format: "CFA{{amount}}",
    money_with_currency_format: "CFA{{amount}} XOF",
  },
  ZMW: {
    money_format: "K{{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format:
      "ZMW{{amount_no_decimals_with_comma_separator}}",
  },
};
function formatWithDelimiters(o) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
    m = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
    r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
  if (isNaN(o) || !o) return 0;
  var n,
    a = (o / 100).toFixed(t).split(m);
  return (
    a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(m)) +
    (a[1] ? r + a[1] : "")
  );
}
function formatMoney(o, t) {
  "string" == typeof o && (o = o.replace(".", ""));
  var m = "",
    r = /\{\{\s*(\w+)\s*\}\}/;
  switch (t.match(r)[1]) {
    case "amount":
      m = formatWithDelimiters(o, 2, ",", ".");
      break;
    case "amount_with_space_separator":
      m = formatWithDelimiters(o, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      m = formatWithDelimiters(o, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      m = formatWithDelimiters(o, 2, "'", ".");
      break;
    case "amount_no_decimals":
    case "amount_no_decimals_with_comma_separator":
      m = formatWithDelimiters(o, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      m = formatWithDelimiters(o, 0, " ", ".");
  }
  return t.replace(r, m);
}
function getCentsValue(o, t, m) {
  var r = 0;
  return -1 !== t.indexOf("amount_no_decimals")
    ? 100 * o
    : "JOD" === m || "KWD" === m || "BHD" === m
    ? o / 10
    : o;
}
function getMoneyValue(o) {
  var t = parseInt(
    (o.getAttribute("data-currency-original") || o.textContent).replace(
      /[^0-9]/g,
      ""
    ),
    10
  );
  return isNaN(t) ? "" : t;
}
Shopify.theme.currencyConverter = {
  init: function o() {
    (this.options = {
      switcherSelector: "[data-currency-converter]",
      priceSelector: "span.money",
      presentmentCurrency: window.Currency.presentment_currency,
      defaultCurrency: window.Currency.default_currency,
      displayFormat: window.Currency.display_format,
      moneyFormat: window.Currency.money_format,
      moneyFormatNoCurrency: window.Currency.money_format_no_currency,
      moneyFormatCurrency: window.Currency.money_format_currency,
    }),
      (this.moneyFormats = window.moneyFormats),
      (this.storage = "currency"),
      (this.currentCurrency = null),
      (this.isInitialised = !1),
      window.Currency &&
        window.Currency.show_multiple_currencies &&
        !this.isInitialised &&
        ($(this.options.switcherSelector).on("click", function (o) {
          o.preventDefault(), o.stopPropagation();
          var t = $(this);
          Shopify.theme.currencyConverter.setCurrency(t.val());
        }),
        (this.currentCurrency =
          this._getStoredCurrency() || this.options.defaultCurrency),
        (this.moneyFormats[
          this.options.presentmentCurrency
        ].money_with_currency_format = this.options.moneyFormatCurrency),
        (this.moneyFormats[this.options.presentmentCurrency].money_format =
          this.options.moneyFormatNoCurrency),
        (this.isInitialised = !0),
        this._current());
  },
  setCurrency: function o(t) {
    this.isInitialised && this._convertAll(t);
  },
  update: function o(t) {
    if (this.isInitialised) {
      for (var m = t.attributes, r = 0; r < m.length; r++) {
        var n = m[r];
        0 === n.name.indexOf("data-currency") && t.setAttribute(n.name, "");
      }
      this._convertEl(t, this.currentCurrency);
    }
  },
  _getStoredCurrency: function o() {
    try {
      return localStorage.getItem(this.storage);
    } catch (t) {
      return console.warn(t), this.options.defaultCurrency;
    }
  },
  _setStoredCurrency: function o(t) {
    try {
      localStorage.setItem(this.storage, t);
    } catch (m) {
      console.warn(m);
    }
  },
  _current: function o() {
    for (
      var t = document.querySelectorAll(this.options.switcherSelector), m = 0;
      m < t.length;
      m += 1
    )
      for (
        var r = t[m].querySelectorAll("option"), n = 0;
        n < r.length;
        n += 1
      ) {
        var a = r[n];
        a.selected && a.value !== this.currentCurrency && (a.selected = !1),
          a.value === this.currentCurrency && (a.selected = !0);
      }
    this._convertAll(this.currentCurrency);
  },
  _convertEl: function o(t, m) {
    var r = this.options.presentmentCurrency;
    if (t.getAttribute("data-currency") !== m) {
      if (t.getAttribute("data-currency-".concat(m)))
        t.innerHTML = t.getAttribute("data-currency-".concat(m));
      else {
        var n = this.moneyFormats[r][this.options.displayFormat],
          a = this.moneyFormats[m][this.options.displayFormat],
          e = getMoneyValue(t),
          u = getCentsValue(e, n, r);
        if ("" === u) return;
        var c = window.Currency.convert(u, r, m),
          y = formatMoney(u, n),
          i = formatMoney(c, a);
        t.getAttribute("data-currency-original") ||
          t.setAttribute("data-currency-original", y),
          t.setAttribute("data-currency-".concat(r), y),
          t.setAttribute("data-currency-".concat(m), i),
          (t.innerHTML = i);
      }
      t.setAttribute("data-currency", m);
    }
  },
  _convertAll: function o(t) {
    var m = document.querySelectorAll(this.options.priceSelector);
    if (m) {
      (this.currentCurrency = t),
        $(".currency-code").text(this.currentCurrency),
        this._setStoredCurrency(t);
      for (var r = 0; r < m.length; r += 1) this._convertEl(m[r], t);
    }
  },
  convertCurrencies: function () {
    if (!this.isInitialised) {
      var o = $(".currency-code").first().text();
      Shopify.theme.currencyConverter.setCurrency(o);
    }
  },
};
